var Marionette = require('marionette'),
    _ = require('underscore');


require('chosenBundle');


module.exports = Marionette.ItemView.extend({

    initialize: function(options) {

        this.onChange = options.onChange;
        this.groups = options.groups; // can be diff for flash notes ....
        this.renderDisabled = options.renderDisabled;

    },

    template: require('./template.hbs'),

    onRender: function() {

        this.unwrap(); // required for plugin markup -- see note in consultGroupSelector

        // I don't think ever had to handle situation where note access group didn't exist ...
        this.options.selectedGroupId &&
            this.$el.val( this.options.selectedGroupId );

    },

    serializeData: function() {

        //if (this.options.useDescription) {
        //
        //}

        return {
            groups: this.groups,
            renderDisabled: this.renderDisabled
        };

    },

    // ( Chosen must be in DOM )
    onShow: function() {

        this.$el.chosen({
            width: '100%'
        }).on('change', _.bind( function() {

            this.onChange( this.getSelectedGroup() );

        }, this) );
    },

    getSelectedGroup: function() {

        var selectedGroupId = parseInt( this.$el.val() ),
            selectedGroup =  _.findWhere( this.groups,{ groupId:selectedGroupId } );

        return selectedGroup;

    },

    onBeforeDestroy: function() {

        this.$el
            .off()
            .chosen('destroy');

    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/views/note/accessGroupSelector/view.js
 ** module id = 173
 ** module chunks = 0
 **/